<template>
  <div class="am-agency-buzz-icon">
    <a v-if="isAgencyBuzz===1" href="javascript:void(0)" @click="insertAgencyBuzzSyncRecord" title="Agency Buzz">
      <svg-icon icon="agencyBuzz" class="am-glyphicon-medium" title="Agency Buzz"></svg-icon>
    </a>
  </div>
</template>

<script>
    import api from './../http'
    export default {
      name: "AgencyBuzz",
      data() {
        return {
          isAgencyBuzz: 0
        }
      },
      props: {
        masterId: {
          type: Number,
          default: 0
        }
      },

      mounted() {
        this.checkAgencyBuzzPermission()
      },

      methods: {
        insertAgencyBuzzSyncRecord() {
          let self = this
          api.postRequest('backoffice/agency-buzz-sync/add', {'masterId' : self.masterId})
        },

        checkAgencyBuzzPermission() {
          let self = this
          api.postRequest('backoffice/agency-buzz-sync/checkPermission', {'masterId' : self.masterId}).then(
            (data) => {
              self.isAgencyBuzz = data.data.results
            })
          return self
        }
      }
    }
</script>

<style scoped>
  .am-agency-buzz-icon{
    float:left;
    display:block;
    padding: 0px 3px 0px 0px
  }
</style>
